import Operator from "./Operator";

export class OperatorState {
  operator?: Operator;
  constructor() {
    this.operator = { id: "", active: true, code: "", firstName: "", firstSurname: "", password: "", secondSurname: "" };
  }
}
